import React, {useState} from "react";
import logo from '../assets/servimaxlogo.jpg'
import changeCamaraImage from '../assets/change-camara.png'
import cedula_anverso from '../assets/cedula_anverso.png';
import cedula_reverso from '../assets/cedula_reverso.jpg';
import Webcam from "react-webcam";

const FACING_MODE_USER = "user";
const FACING_MODE_ENVIRONMENT = "environment";

const videoConstraints = {
    facingMode: FACING_MODE_USER
};
const Capture = ({state, imageIdentification, setImageIdentification, webcamRef, nextState, save}) => {

    const [facingMode, setFacingMod] = useState(FACING_MODE_USER);
    const changeCamara = React.useCallback(() => {
        setFacingMod(
            prevState => prevState === FACING_MODE_USER ? FACING_MODE_ENVIRONMENT : FACING_MODE_USER
        )
    }, []);

    const capture = React.useCallback(() => {
        const imageSrc = webcamRef.current.getScreenshot();
        if (state === 'SELFIE') {
            setImageIdentification({
                selfie: {
                    upload: true,
                    photo: imageSrc
                },
                reverse: imageIdentification.reverse,
                obverse: imageIdentification.obverse
            })
            return;
        }
        if (state === 'OBVERSE') {
            setImageIdentification({
                obverse: {
                    upload: true,
                    photo: imageSrc
                },
                reverse: imageIdentification.reverse,
                selfie: imageIdentification.selfie,
            })
            return;
        }
        if (state === 'REVERSE') {
            setImageIdentification({
                selfie: imageIdentification.selfie,
                obverse: imageIdentification.obverse,
                reverse: {
                    upload: true,
                    photo: imageSrc
                }
            })
            return;
        }
    })

    const clean = () => {
        if (state === 'SELFIE') {
            setImageIdentification({
                selfie: {
                    upload: false,
                    photo: null
                },
                obverse: imageIdentification.obverse,
                reverse: imageIdentification.reverse,
            })
            return;
        }
        if (state === 'OBVERSE') {
            setImageIdentification({
                obverse: {
                    upload: false,
                    photo: null
                },
                reverse: imageIdentification.reverse,
                selfie: imageIdentification.selfie,
            })
            return;
        }
        if (state === 'REVERSE') {
            setImageIdentification({
                selfie: imageIdentification.selfie,
                obverse: imageIdentification.obverse,
                reverse: {
                    upload: false,
                    photo: null
                }
            })
            return;
        }
    }

    const getCamOrImg = () => {
        if (state === 'SELFIE') {
            if (!imageIdentification.selfie.upload) {
                return <Webcam audio={false}
                               ref={webcamRef}
                               screenshotFormat="image/jpeg"
                               videoConstraints={{
                                   ...videoConstraints,
                                   facingMode
                               }}
                />
            } else {
                return <img src={imageIdentification.selfie.photo}/>
            }
        }
        if (state === 'OBVERSE') {
            if (!imageIdentification.obverse.upload) {
                return <Webcam audio={false}
                               ref={webcamRef}
                               screenshotFormat="image/jpeg"
                               videoConstraints={{
                                   ...videoConstraints,
                                   facingMode
                               }}
                />
            } else {
                return <img src={imageIdentification.obverse.photo}/>
            }
        }
        if (state === 'REVERSE') {
            if (!imageIdentification.reverse.upload) {
                return <Webcam audio={false}
                               ref={webcamRef}
                               screenshotFormat="image/jpeg"
                               videoConstraints={{
                                   ...videoConstraints,
                                   facingMode
                               }}
                />
            } else {
                return <img src={imageIdentification.reverse.photo}/>
            }
        }
    }
    const getActionCapture = () => {
        if (state === 'SELFIE') {
            if (!imageIdentification.selfie.upload) {
                return <button className="btn btn-danger m-1" onClick={capture}>Tomar foto</button>
            } else {
                return <button className="btn btn-danger m-1" onClick={clean}>Limpiar foto</button>
            }
        }
        if (state === 'OBVERSE') {
            if (!imageIdentification.obverse.upload) {
                return <button className="btn btn-danger m-1" onClick={capture}>Tomar foto</button>
            } else {
                return <button className="btn btn-danger m-1" onClick={clean}>Limpiar foto</button>
            }
        }
        if (state === 'REVERSE') {
            if (!imageIdentification.reverse.upload) {
                return <button className="btn btn-danger m-1" onClick={capture}>Tomar foto</button>
            } else {
                return <button className="btn btn-danger m-1" onClick={clean}>Limpiar foto</button>
            }
        }
    }
    const getTextInformation = () => {
        if (state === 'SELFIE') {
            return <span className="message-text">Para una identificación precisa, requerimos una foto de su rostro.</span>;
        }
        if (state === 'OBVERSE') {
            return (
                <div className="text-center">
                    <span style={{fontSize: 18, fontWeight: "bold"}}><b>Toma una foto del ANVERSO de tu documento de identidad.</b></span>
                    <br/>
                    <img src={cedula_anverso} alt="" width="65%"/>
                </div>
            )
        }
        if (state === 'REVERSE') {
            return (
                <div className="text-center">
                    <span style={{fontSize: 18, fontWeight: "bold"}}>Toma una foto del REVERSO de tu documento de identidad.</span>
                    <br/>
                    <img src={cedula_reverso} alt="" width="65%"/>
                </div>
            );
        }
        return <span>Error</span>
    }
    const getActionNextSave = () => {
        if (state === 'SELFIE') {
            return <button className="btn btn-secondary"
                           disabled={!imageIdentification.selfie.upload}
                           onClick={() => nextState('OBVERSE')}>Siguiente</button>
        }
        if (state === 'OBVERSE') {
            return <button className="btn btn-secondary"
                           disabled={!imageIdentification.obverse.upload}
                           onClick={() => nextState('REVERSE')}>Siguiente</button>
        }
        if (state === 'REVERSE') {
            return <button className="btn btn-secondary"
                           disabled={!imageIdentification.reverse.upload}
                           onClick={save}>Enviar</button>
        }
    }
    return (
        <div className="card">
            <div className="card-header" style={{background: 'red'}}>
            </div>
            <img src={logo} alt=""/>
            {getTextInformation()}
            <p/>
            {getCamOrImg()}
            <p/>
            <div className="text-center">
                <button className="btn btn-secondary"
                        onClick={changeCamara}>
                    <img src={changeCamaraImage} width="22"/>
                </button>
                {getActionCapture()}
                {getActionNextSave()}
            </div>
        </div>
    );
}
export default Capture;